import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setOpenDialog } from "../../../Redux/slices/settingsSlice";
import MainPara from "Screens/components/MainPara";
import Sold from "Utils/Assets/Images/Sold2.png";
import * as Icons from "react-bootstrap-icons";
import Rarible from "Utils/Assets/Images/Rarible_Logo.png";
import { Link } from "react-router-dom";
import { useSetState } from "Utils/Helpers/Hooks";
import { Grid2 } from "@mui/material";
import MuiRadioGroup from "Utils/Helpers/MuiRadioGroup";
import MPaper from "Utils/Helpers/MPaper";

const price_filter_items = [
  { key: "None", value: "0" },
  { key: "Ascending", value: "1" },
  { key: "Descending", value: "2" },
];

const date_filter_items = [
  { key: "None", value: "0" },
  { key: "Oldest", value: "1" },
  { key: "Newest", value: "2" },
];

export default function Characters({ filters, onChangeFilter }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [controls, setControls] = useSetState({
    price: {
      label: "Price",
      type: "radio",
      value: price_filter_items[0],
      items: price_filter_items,
      size: { md: 6, sm: 12, xs: 12 },
    },
    date: {
      label: "Date",
      type: "radio",
      value: date_filter_items[0],
      items: date_filter_items,
      size: { md: 6, sm: 12, xs: 12 },
    },
  });

  const { character } = useSelector((state) => ({
    character: state.data.character,
  }));

  useEffect(() => {
    setControls({
      price: {
        value: price_filter_items.find((i) => +i.value === +filters.price),
      },
    });
    setControls({
      date: {
        value: date_filter_items.find((i) => +i.value === +filters.price),
      },
    });
  }, []);

  useEffect(() => {
    if (character) {
      setData(character.data);
    }
  }, [character]);

  const onChangeRadio = (name, value) => {
    setControls({ [name]: { value: value } });
    onChangeFilter(name, +value.value || 0);
  };

  const onCharacterClick = (data) => {
    dispatch(
      setOpenDialog({
        title: data.code,
        image: data.image,
        content: t(data.description),
      })
    );
  };

  return (
    <>
      <MainPara
        title={"92631TchPDes26315367244"}
        text={"92631BchPDes26315367244"}
        charType
        align={"text-left"}
      />

      <Grid2 container className="w-100">
        <MPaper
          label={"Filters"}
          className="character-filters"
          content={
            <Grid2 container spacing={2}>
              {Object.keys(controls).map((key, index) => {
                return (
                  <Grid2 size={controls[key].size} key={key + index}>
                    {controls[key].type === "radio" && (
                      <MuiRadioGroup
                        name={key}
                        value={controls[key].value}
                        label={controls[key].label}
                        items={controls[key].items}
                        onChange={onChangeRadio}
                      />
                    )}
                  </Grid2>
                );
              })}
            </Grid2>
          }
        />
      </Grid2>

      <div className="character-exhibition">
        {data &&
          data.map((item) => {
            return (
              <div
                key={item.id}
                // offset={0}
                className={`character-box status-${item.status}`}
              >
                {item.status === 1 && (
                  <div className="character-select">
                    <p>
                      Buy at <span>{item.price}</span> {item.unit}
                    </p>
                    <div className="btn-raribuy">
                      <Link
                        to={item.burl || ""}
                        target="_blank"
                        disabled={!item.burl || item.burl === ""}
                      >
                        Buy
                      </Link>
                      {item.burl &&
                        item.burl !== "" &&
                        item.burl.includes("https://rarible.com") && (
                          <div className="rari-info">
                            <span>Buy from</span>
                            <img src={Rarible} alt="Rarible" />
                          </div>
                        )}
                    </div>
                    <button onClick={() => onCharacterClick(item)}>
                      Details
                    </button>
                  </div>
                )}
                <div className="character-code">
                  {item.code !== "" && (
                    <>
                      <Icons.Hash />
                      <span>{item.code}</span>
                    </>
                  )}
                </div>
                <div className={`character-image status-${item.status}`}>
                  {item.status === 2 && (
                    <div className="character-image-sold">
                      <img src={Sold} alt="SOLD" />
                    </div>
                  )}
                  <img
                    style={{ maxWidth: "280px" }}
                    src={item.image}
                    alt={item.name}
                  />
                </div>
                {item.name !== "" && (
                  <div className="character-name">
                    <Icons.CardText />
                    <span>{item.name}</span>
                  </div>
                )}
                <div className={`character-price status-${item.status}`}>
                  <span>
                    {
                      {
                        1: `${t("Price")}:`,
                        2: t("Sold out"),
                        3: t("Unsellable"),
                      }[item.status]
                    }
                  </span>
                  {item.status === 1 && <span>{item.price}</span>}
                  {item.status === 1 && <span>{item.unit}</span>}
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
}
